import { useEffect, useState, useRef } from "react";
import CabecalhoPadrao from "../components/CabecalhoPadrao/CabecalhoPadrao";
import DropdownPadrao from "../components/DropdownPadrao/DropdownPadrao";
import FiltroPadrao from "../components/FiltroPadrao/FiltroPadrao";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import TabelaPadrao from "../components/TabelaPadrao/TabelaPadrao";
import ModalSistemas from "../components/ModalSistemas/ModalSistemas";
import FiltroURLWrapper from "../hooks/FiltroUrlHook";
import api from '../services/api';
import FiltroUtils from '../utils/FiltroUtils';
import { isSuperAdmin, PERMISSOES } from "../utils/PermissaoUtils";
import PAGINATION from "../utils/PaginacaoUtils";
import Carregamento from "../components/Carregamento/Carregamento";
import { BREAKPOINTS_PADRAO, OPCOES_SITUACAO, definirColunasFixas, criarColuna, COLUNA_SITUACAO_SISTEMA } from "../utils/ListagemUtils";
import Mensagens from "../utils/MensagemUtils";
import NotificacaoUtils from "../utils/NotificacaoUtils";
import { FaRegTrashAlt } from "react-icons/fa";
import { useEmpresa } from "../hooks/DropdownHooks";
import "./Cadastros.css";

const ListagemEquipamento = () => {

    const [equipamentos, setEquipamentos] = useState([]);
    const [totalEquipamentos, setTotalEquipamentos] = useState(0);
    const [carregando, setCarregando] = useState(false);
    const [buscaInicial, setBuscaInicial] = useState(true);
    const { itens: empresas, carregando: carregandoEmpresas } = useEmpresa();
    const [modalConfirmacaoAberto, setModalConfirmacaoAberto] = useState(false);
    const [equipamentoParaRemover, setEquipamentoParaRemover] = useState(null);

    const filtrarRef = useRef(null);
    const currentPageRef = useRef(PAGINATION.DEFAULT_FIRST_PAGE);

    const carregamentoGeral = () => carregando || carregandoEmpresas;
    
    const filtrosPadrao = {
        numeroSerie: '',
        unidade: '',
        razaoSocial: '',
        documento: '',
        situacaoCadastroSistema: '',
        idEmpresa: '',
    };

    const colunas = [
        criarColuna(Mensagens.EQUIPAMENTO.LISTAGEM.COLUNA_NUMERO_SERIE, 'numeroSerie'),
        criarColuna(Mensagens.EQUIPAMENTO.LISTAGEM.COLUNA_UNIDADE, 'sistema.unidade'),
        criarColuna(Mensagens.EQUIPAMENTO.LISTAGEM.COLUNA_RAZAO_SOCIAL, 'cliente.razaoSocial'),
        criarColuna(Mensagens.EQUIPAMENTO.LISTAGEM.COLUNA_DOCUMENTO, 'cliente.documento'),
        COLUNA_SITUACAO_SISTEMA(obj => obj.sistema?.situacaoCadastro),
    ];
    
    const colunasFixas = definirColunasFixas();
    useEffect(() => {
    // Garantir que a busca inicial seja feita com situacaoCadastro=ATIVO
    if (filtrarRef.current) filtrarRef.current(0); // Forçar página 0 para busca inicial
}, []);

let modalTitulo = Mensagens.EQUIPAMENTO.MODAL_DESVINCULAR_TITULO;
let modalSubtitulo = Mensagens.EQUIPAMENTO.MODAL_DESVINCULAR_SUBTITULO;
let modalExplicacao = Mensagens.EQUIPAMENTO.MODAL_DESVINCULAR_EXPLICACAO;

const abrirModalConfirmacao = (equipamento) => {
    setEquipamentoParaRemover(equipamento);
    setModalConfirmacaoAberto(true);
};

const fecharModalConfirmacao = () => {
    setModalConfirmacaoAberto(false);
    setEquipamentoParaRemover(null);
};

const confirmarRemocaoEquipamento = async () => {
    if (!equipamentoParaRemover) return;
    
    setCarregando(true);
    try {
        const response = await api.delete(`/equipamento_/removerVinculo/${equipamentoParaRemover.idEquipamento}`);
        if (response.success) {
            NotificacaoUtils.sucesso(response.message || Mensagens.EQUIPAMENTO.REMOVER_VINCULO_SUCESSO);
            fecharModalConfirmacao();
            // Recarregar a lista após remoção
            if (filtrarRef.current) {
                filtrarRef.current(currentPageRef.current);
            }
        } else {
            NotificacaoUtils.erro(response.message || Mensagens.EQUIPAMENTO.REMOVER_VINCULO_ERRO);
        }
    } catch (error) {
        NotificacaoUtils.erro(Mensagens.EQUIPAMENTO.REMOVER_VINCULO_ERRO);
    } finally {
        setCarregando(false);
    }
};    

const aplicaDestaqueTexto = (texto, numeroSerie, unidade) => {
  const partes = texto.split(/(\{numeroSerie\}|\{unidade\})/);
  
  return partes.map((parte, index) => {
    if (parte === '{numeroSerie}') {
      return <span key={index} className="destaque">{numeroSerie}</span>;
    } else if (parte === '{unidade}') {
      return <span key={index} className="destaque">{unidade}</span>;
    }
    return parte;
  });
};

return (
      <FiltroURLWrapper
        defaultFilters={filtrosPadrao}
        defaultPage={PAGINATION.DEFAULT_FIRST_PAGE}
        defaultSize={PAGINATION.DEFAULT_PAGE_SIZE}
        basePath={'/equipamento/visualizar'}
      >
        {({
          currentPage,
          pageSize,
          filtros,
          setFiltros,
          aplicarFiltros,
          limparFiltros,
          proximaPagina,
          paginaAnterior,
          irParaPagina,
        }) => {
          const fetchEquipamentos = async queryString => {
            setCarregando(true);
            try {
              const apiResponse = await api.get('/equipamento_' + queryString);
              if (apiResponse.success) {
                const data = apiResponse.data;
                const equipamentos = data.content;
                const page = data.page;
                setEquipamentos(equipamentos);
                setTotalEquipamentos(page.totalElements);
              } else {
                NotificacaoUtils.erro(Mensagens.ERRO.ERRO_BUSCAR_DADOS);
                setEquipamentos([]);
                setTotalEquipamentos(0);
              }
            } catch (error) {
              console.error(Mensagens.EQUIPAMENTO.LISTAGEM.ERRO_BUSCAR, error);
              NotificacaoUtils.erro(Mensagens.ERRO.ERRO_BUSCAR_DADOS);
              setEquipamentos([]);
              setTotalEquipamentos(0);
            } finally {
              setCarregando(false);
            }
          };

          // filtrar agora aceita page como argumento
          const filtrar = async (page = 0) => {
            // Se for a busca inicial (primeira execução) e não há filtro de situação definido, aplicar ATIVO
            if (buscaInicial && !filtros.situacaoCadastroSistema) {
              const filtrosComSituacao = { ...filtros, situacaoCadastroSistema: "ATIVO" };
              // Atualiza o estado dos filtros para que o dropdown mostre "ATIVO"
              setFiltros(filtrosComSituacao);
              setBuscaInicial(false);
              
              const queryStringComSituacao = FiltroUtils.applyPageFilter(page, pageSize, filtrosComSituacao);
              await fetchEquipamentos(queryStringComSituacao);
            } else {
              // Para buscas subsequentes, usar os filtros exatamente como o usuário definiu
              aplicarFiltros(page);
              const queryString = FiltroUtils.applyPageFilter(page, pageSize, filtros);
              await fetchEquipamentos(queryString);
            }
          };
          
          if (filtrarRef.current !== filtrar) {
            filtrarRef.current = filtrar;
          }
          
          if (currentPageRef.current !== currentPage) {
            currentPageRef.current = currentPage;
            filtrar(currentPage);
          }

          // Sempre que pesquisar, volta para página 0 e filtra
          const pesquisar = async () => {
            setBuscaInicial(false); // Marcar que não é mais busca inicial
            irParaPagina(0);
            await filtrar(0);
          };

          // Função customizada para limpar filtros
          const limparFiltrosCustom = () => {
            setBuscaInicial(false); // Marcar que não é mais busca inicial
            limparFiltros();
          };

          return (
            <div>
              {carregamentoGeral() && <Carregamento />}

              <CabecalhoPadrao
                titulo={Mensagens.EQUIPAMENTO.LISTAGEM.TITULO}
                permissao={false}
                onClick={() => {}}
              />

              <FiltroPadrao 
                filtrar={pesquisar} 
                limparFiltros={limparFiltrosCustom}
                expansivo={true}
                expandedChildren={
                  <>
                    <InputPadrao
                      label={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_RAZAO_SOCIAL}
                      placeholder={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_RAZAO_SOCIAL_PLACEHOLDER}
                      value={filtros.razaoSocial}
                      name="razaoSocial"
                      onChange={e => setFiltros({ ...filtros, razaoSocial: e.target.value })}
                    />
                    <InputPadrao
                      label={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_DOCUMENTO}
                      placeholder={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_DOCUMENTO_PLACEHOLDER}
                      value={filtros.documento}
                      name="documento"
                      onChange={e => setFiltros({ ...filtros, documento: e.target.value })}
                    />
                  </>
                }
              >
                <DropdownPadrao
                  label={Mensagens.CLIENTE.LISTAGEM.FILTRO_EMPRESA}
                  showFilter={true}
                  options={empresas}
                  value={filtros.idEmpresa}
                  name="idEmpresa"
                  exibirSe={isSuperAdmin()}
                  onChange={e => setFiltros({ ...filtros, idEmpresa: e.target.value })}
                />

                <InputPadrao
                  label={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_NUMERO_SERIE}
                  placeholder={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_NUMERO_SERIE_PLACEHOLDER}
                  value={filtros.numeroSerie}
                  name="numeroSerie"
                  onChange={e => setFiltros({ ...filtros, numeroSerie: e.target.value })}
                  style={{ flexBasis: '2rem' }}
                />
                <InputPadrao
                  label={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_UNIDADE}
                  placeholder={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_UNIDADE_PLACEHOLDER}
                  value={filtros.unidade}
                  name="unidade"
                  onChange={e => setFiltros({ ...filtros, unidade: e.target.value })}
                />

                <DropdownPadrao
                  label={Mensagens.EQUIPAMENTO.LISTAGEM.FILTRO_SITUACAO_SISTEMA}
                  showFilter={true}
                  options={OPCOES_SITUACAO}
                  value={filtros.situacaoCadastroSistema}
                  name="situacaoCadastroSistema"
                  onChange={e => setFiltros({ ...filtros, situacaoCadastroSistema: e.target.value })}
                />
              </FiltroPadrao>

              <TabelaPadrao
                permissaoEditar={PERMISSOES.EQUIPAMENTO_REMOVER}
                dados={equipamentos}
                colunas={colunas}
                totalItems={totalEquipamentos}
                paginaAtual={currentPage}
                tamanhoPagina={pageSize}
                carregando={carregando}
                onEditar={abrirModalConfirmacao}
                onProximaPagina={proximaPagina}
                onPaginaAnterior={paginaAnterior}
                onIrParaPagina={irParaPagina}
                colunasFixas={colunasFixas}
                breakpoints={BREAKPOINTS_PADRAO}
                iconeAcao={<FaRegTrashAlt />}
                tooltipMessage={Mensagens.EQUIPAMENTO.LISTAGEM.TOOLTIP_DESVINCULAR}
              />

              <ModalSistemas
                aberto={modalConfirmacaoAberto}
                onClose={fecharModalConfirmacao}
                titulo={modalTitulo}
                subtitulo={aplicaDestaqueTexto(
                  modalSubtitulo,
                  equipamentoParaRemover?.numeroSerie || '',
                  equipamentoParaRemover?.sistema?.unidade || ''
                )}
                tamanhoEtapa={45}
                onConfirmar={confirmarRemocaoEquipamento}
                onCancelar={fecharModalConfirmacao}
              >
                <div className="modal-confirma-desvinculacao">
                  <p>{modalExplicacao}</p>
                </div>
              </ModalSistemas>
            </div>
          );
        }}
      </FiltroURLWrapper>
    );
};

export default ListagemEquipamento;
